import { render, staticRenderFns } from "./title.vue?vue&type=template&id=8f955cc2&scoped=true"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"
import style0 from "./title.vue?vue&type=style&index=0&id=8f955cc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f955cc2",
  null
  
)

export default component.exports